module.exports = __webpack_public_path__ + "media/images/mobile/Mask Group 4-16efeb6c7bcb9aad6886a4cb08c786f1.png";